import { useNavigate } from "react-router-dom";
import { Dashboard, EmptyState } from "../components/index.js";
import { useApiClient } from "../api/ApiContext.jsx";
import { useApi } from "../hooks/useApi.js";
import { AsyncBoundary } from "../ui/Feedback.jsx";

export default function DashboardScreen() {
  const api = useApiClient();
  const navigate = useNavigate();
  const query = useApi(() => api.dashboard(), [api]);

  return (
    <AsyncBoundary query={query} onBack={() => navigate("/")}>
      {(data) =>
        data.projects.length === 0 ? (
          <EmptyState onCreateProject={() => navigate("/projects/new")} />
        ) : (
          <Dashboard
            plan={data.plan}
            stats={data.stats}
            projects={data.projects}
            onNewProject={() => navigate("/projects/new")}
            onOpenProject={(projectId) => navigate(`/projects/${projectId}`)}
            // The provider travels as a query parameter rather than as route
            // state: the filtered list is a place, and a customer who reloads or
            // shares the URL should land on the same view.
            onOpenProvider={(projectId, provider) =>
              navigate(`/projects/${projectId}?provider=${encodeURIComponent(provider)}`)
            }
          />
        )
      }
    </AsyncBoundary>
  );
}
